import {Injectable} from '@angular/core';

@Injectable()
export class CommandsGraphics3dSurfaces {
    constructor() {

    }

    addTriangle() {
    }

    addVertex() {
    }

    clearSurface() {
    }

    countSurfaces() {
    }

    countTriangles() {
    }

    countVertices() {
    }

    createSurface() {
    }

    findSurface() {
    }

    getSurface() {
    }

    triangleVertex() {
    }

    updateNormals() {
    }

    vertexAlpha() {
    }

    vertexBlue() {
    }

    vertexColor() {
    }

    vertexCoords() {
    }

    vertexGreen() {
    }

    vertexNormal() {
    }

    vertexNX() {
    }

    vertexNY() {
    }

    vertexNZ() {
    }

    vertexRed() {
    }

    vertexTexCoords() {
    }

    vertexU() {
    }

    vertexV() {
    }

    vertexW() {
    }

    vertexX() {
    }

    vertexY() {
    }

    vertexZ() {
    }
}
